import styled from 'styled-components';



function MainDishesh({className=""}) {
  return (
    <DIV className={`${className}`}>
            main dishesh
    </DIV>
  );
}


const DIV=styled.div`
    width: 100%;

 
`;

export default MainDishesh;
